import { jsx as _jsx } from "react/jsx-runtime";
import { memoForwardRef } from "@shared/client/util/memo";
import "./slate-content.scss";
export const SlateContent = memoForwardRef(({ children }, ref) => {
    return _jsx("div", { ref: ref, className: "slate-content", children: children });
});
